export type { TabsProps, TabRender, TabRendererOptions } from './Tabs.types'
export { default as Tabs } from './Tabs'